<template>
  <div class="mid_scroll_content">
    <loader v-show="pageLoader"></loader>
    <section class="depoist_fund border-0 pb-5 h-100">
      <div
        class="row justify-content-center align-items-center custom-max-width h-100"
      >
        <div :class="[{ 'col-md-9 col-12': call_from == '' }]">
          <alert-notification v-if="notification_msg != ''" />
          <div v-if="div_show == ''">
            <div class="twoFa-img">
              <img
                src="../../../../static/website/images/4112331.svg"
                alt="2FA"
              />
            </div>
            <div
              class="alrtMessage my-3"
              v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 1"
            >
              <p class="mb-0 position-relative pl-5 alert alert-warning">
                <feather class="alertIcon" type="alert-octagon"></feather>For
                security purposes, withdrawals will be temporarily suspended for
                24 hours once you disable 2FA. The withdrawal function will be
                automatically enabled when the time is up.
              </p>
            </div>
            <div
              class="twofa_activate mt-3 mb-5 d-flex align-items-center justify-content-between border p-4"
            >
              <div class="title section_title m-0">
                <h5>Two-Factor Authentication</h5>
                <span
                  class="activate"
                  v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 1"
                >
                  Enabled</span
                >
                <span class="notactivate" v-else> Set up 2FA</span>
              </div>
              <div class="enable">
                <a
                  href="#"
                  class="cap_btn pl-3 pr-3 large_btn red"
                  @click.prevent="enable_disable_func('2')"
                  v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 1"
                >
                  Disable 2FA</a
                >
                <a
                  href="#"
                  class="cap_btn blue pl-3 pr-3 large_btn"
                  @click.prevent="enable_disable_func('1')"
                  v-else
                >
                  Enable 2FA</a
                >
              </div>
            </div>
          </div>

          <div v-else-if="div_show == '1'">
            <div class="authSteps p-0">
              <div class="head text-center pb-4 mb-md-5">
                <h2>Enable Two-Factor Authentication</h2>
                <p>Verify your Registeration and keep your account safe with 3 quick steps:</p>
              </div>
              <div class="twoauthSteps">
                <div class="d-flex align-items-center border-bottom mb-4 pb-4">
                  <div class="ico mr-3">
                    <img
                      src="../../../../static/website/images/google_auth.png"
                      alt="Authenticator APP"
                    />
                  </div>
                  <div class="desc text-left">
                    <h5 class="mb-3">Download an Authenticator App</h5>
                    <p>
                      Download and install Authy or Google Authenticator to your
                      phone or tablet.
                    </p>
                  </div>
                </div>
                <div class="d-flex align-items-center border-bottom mb-4 pb-4">
                  <div class="ico mr-3">
                    <img :src="src_data" alt="Icon" />
                  </div>
                  <div class="desc text-left">
                    <h5 class="mb-3">Scan The QR Code</h5>
                    <p class="mb-3">
                      Open the authentication app and scan the image to the
                      left, using your phone's camera.
                    </p>
                  </div>
                </div>
                <div class="d-flex align-items-center mb-4 pb-4">
                  <div class="ico mr-3">
                    <img
                      src="../../../../static/website/images/otp4.svg"
                      alt="IconAPP"
                    />
                  </div>
                  <div class="desc text-left">
                    <h5 class="mb-3">Log in with your Code</h5>
                    <p class="mb-3">
                      Enter the 6-digit verification code generated by the Authenticator and login into your new Capital Wallet account.
                    </p>
                    <div class="authenticator_input d-flex align-items-center">
                      <input
                        type="text"
                        v-model="otp"
                        aria-required="true"
                        aria-invalid="false"
                        maxlength="6"
                        v-validate="'required|numeric|max:6'"
                        name="otp"
                        class="form-control"
                        placeholder="000 000"
                        :class="[
                          { 'is-invalid': submitted && errors.has('otp') },
                          { disabled: pageLoader },
                        ]"
                        @keyup.enter="verifyQrCode()"
                      />
                      <!--<button class="cap_btn blue ml-2" data-toggle="modal" data-target="#myModal" v-on:click="verifyQrCode()"> Activate</button>-->
                      <button
                        class="cap_btn blue"
                        :class="pageLoader ? 'disabled' : ''"
                        v-on:click="verifyQrCode()"
                      >
                        Verify & Login
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="disableQrCode" v-else-if="div_show == '2'">
            <div class="authSteps p-0 text-center">
              <div class="icoDisable">
                <img
                  src="../../../../static/website/images/4112331.svg"
                  alt="IconAPP"
                />
              </div>
              <div class="twoauthSteps">
                <h5>Please Enter OTP to Disable QR Code</h5>
                <p class="mb-3">
                  Enter the 6-digit verification code generated.
                </p>
                <div
                  class="authenticator_input d-flex align-items-center justify-content-center"
                >
                  <input
                    type="text"
                    v-model="DisableOtp"
                    maxlength="6"
                    v-validate="'required|numeric|max:6'"
                    name="DisableOtp"
                    class="form-control"
                    :class="[
                      { 'is-invalid': submit && errors.has('DisableOtp') },
                      { disabled: pageLoader },
                    ]"
                    placeholder="000 000"
                    @keyup.enter="disableQrCode()"
                  />
                  <button
                    class="cap_btn red ml-2"
                    :class="pageLoader ? 'disabled' : ''"
                    v-on:click="disableQrCode()"
                  >
                    Disable 2FA
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="depoist_fund  pb-5">
			<div class="section_title">
				<h5>SMS Authenticator</h5>
			</div>
			<div class="row justify-content-center">
				<div class="col-8">
					<p> Please enable your Mobile Number for SMS Message Verification and increase your account security</p> 
					<div class="between-button">
					<div class="form-group">
						<input type="text" class="form-control" name="" required="">
						<label class="labeltext">Enter Mobile Number</label>
					</div>
					<input type="submit" class="cap_btn pull-right green blue" value="Verify" name="">
					</div>
					<div class="form-group text-center">
						<input type="submit" class="w-custom cap_btn" value="Change Number" name="">
						<input type="submit" class="w-custom cap_btn red" value="Delete Number" name="">
						
					</div>
					<div class="form-group">
						
					</div>
				</div>
			</div> 
		</section>-->
  </div>
</template>
<script>
import * as types from "@/types";
import { mapActions } from "vuex";
export default {
  name: "two-FA",
  data() {
    return {
      //============message and loader ===========
      response_msg: "",
      pageLoader: false,
      notification_msg: "",
      notification_type: "",
      msg_type: "",
      src_data: "",
      otp: "",
      DisableOtp: "",
      submitted: false,
      submit: false,
      disableFieldShow: false,
      div_show: "",
    };
  },
  props: {
    call_from: { default: "" },
  },
  methods: {
    abc() {
      return null;
    },
    getBack() {
      // return null
    },
    enable_disable_func(getData) {
      this.div_show = getData;
    },
    disableQrCode() {
      if (this.pageLoader) {
        return;
      }
      const _that = this;
      _that.submit = true;
      _that.$validator.validate().then((valid) => {
        if (valid) {
          let input_json = {
            globalParams: {
              google_token: _that.DisableOtp.toString(),
            },
            localParams: { parameter: _that },
          };
          _that._runDisable2FaQrcode(input_json);
        }
      });
    },
    generateQrCode() {
      if (this.pageLoader) {
        return;
      }
      let input_json = {
        globalParams: {},
        localParams: { parameter: this },
      };
      this._runGenerate2FaQrcode(input_json);
    },
    verifyQrCode() {
      if (this.pageLoader) {
        return;
      }
      const _that = this;
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let input_json = {
            globalParams: {
              google_token: _that.otp.toString(),
            },
            localParams: { parameter: _that, call_from: this.call_from },
          };
          _that._runVerify2FaQrcode(input_json);
        }
      });
    },
    ...mapActions({
      _runstateLoad: types.RUN_STATE_LOAD,
    }),
  },
  created() {
    this.pageName("Google Authenticator");
    if (parseInt(this.get_user.profile.gAuthenticatorEnabled) == 0) {
      this.generateQrCode();
    }
    if (this.call_from != "" && this.call_from != null) {
      this.enable_disable_func("1");
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/security/security.vue